import api from "../../index";

export const CreateClientApi = (data) => api.post("add-client-by-admin", data);
export const GetClientByIdApi = (data) => api.post("clientinfo", data);
export const ChangeClientStatusApi = (data) => api.post("update-user-status", data);
export const DeleteClientApi = (data) => api.post("delete-client", data);
export const ResetClientPasswordApi = (data) => api.post("client-password-reset", data);
export const ExportClientsApi = (data, headers) => api.post("export-client", data, headers);

// Documents
export const GetClientDocumentsApi = (data) => api.post("filefolderlist", data);
export const DownloadFileFolderApi = (data, headers) => api.post("download-file-folder", data, headers);
export const GetChildFolderListApi = (data) => api.post("viewfilefolder", data);
export const DeleteFileFolderApi = (data) => api.post("deletefilefolder", data);
export const UploadFileFolderApi = (data, headers) => api.post("uploadfilefolder", data, headers);
export const MoveFileFolderApi = (data) => api.post("movefilefolder", data);
export const DownloadMultipleFileFolderApi = (data, headers) => api.post('download-multiple-file-folder', data, headers);

// Communication
export const GetOrganizerListApi = (data) => api.post("clientorganizerlist", data);
export const CreateChatApi = (data) => api.post("chatcreate", data);
export const GetActiveChatApi = (data) => api.post("chatroomsbydate", data);
export const GetArchiveChatApi = (data) => api.post("archivechatlist", data);
export const GetMessageListApi = (data) => api.post("chatmessageslist", data);

// Notes
export const ViewClientNoteApi = (data) => api.post("notelist", data);
export const SendNoteToClientApi = (data) => api.post("addupdatenotes", data);

// File
export const GetClientFilesApi = (data) => api.post("clientfilelist", data);

// Import
export const GetImportedClientApi = (data) => api.post("get-imported-users", data);

//Overview
export const getOverviewApi = (data) => api.post("client-overview", data);

//Invoice
export const getInvoiceDetailsApi = (data) => api.post("invoice-list", data);

// Signature
export const getSignatureDetailsApi = (data) => api.post("signature-report", data);
